<template>
    <div class="product custom">
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

        <div v-if="preview">
            <div v-if="type === 'api'">
                <customAPI></customAPI>
            </div>
        </div>

        <div v-if="!preview">
            <div v-if="type === 'api'">
                <customAPI></customAPI>
            </div>
            <div v-if="type === 'sales'">
                <customSales></customSales>
            </div>
            <div v-if="type === 'onboarding'">
                <customOnboarding></customOnboarding>
            </div>
        </div>
    </div>
</template>

<style>
    h1 {
        line-height: 28px!important;
    }
</style>

<script>
import ProductMixin from "@/mixins/Product";
import customAPI from "@/components/products/custom/wip/customAPI.vue";
import customSales from "@/components/products/custom/wip/customSales.vue";
import customOnboarding from "@/components/products/custom/wip/customOnboarding.vue";

export default {
    components: {
      customAPI,
      customSales,
      customOnboarding
    },
    data: () => ({
        type: null
    }),
    mixins: [ProductMixin],
    methods: {
        async loaded(data) {
            this.type = data.type;
        }
    }
}
</script>